import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import TopBar from '../../componentsv2/TopBar';
import MarcoLogo from '../../componentsv2/MarcoLogo';
import Typography from '../../componentsv2/Typography';
import Button from '../../componentsv2/Button';
import { ArrowLeftIcon } from '../Icons';
import { useTranslation } from '../../hooks/i18n';
import { COLORS } from '../../themev2';

export default function ErrorBoundary() {
  const { t } = useTranslation();

  const handleNavigate = (path: string) => {
    window.location.href = path;
  };

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh', flexDirection: 'column' }}>
      <TopBar>
        <Box sx={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <IconButton onClick={() => handleNavigate('/')}>
            <MarcoLogo />
          </IconButton>
        </Box>
      </TopBar>
      <Box component="main" sx={{ flexGrow: 1, p: 8, backgroundColor: COLORS.gray[300] }}>
        <Container
          sx={{
            maxWidth: { xs: '100%', sm: 600, md: 600, lg: 1200 },
            padding: '1em 0em',
          }}
        >
          <Grid container>
            <Grid item xs={12}>
              <Typography
                sx={{
                  fontWeight: { xs: 500, md: 600 },
                  fontSize: { xs: '20px', md: '24px' },
                  lineHeight: { xs: '30px', md: '36px' },
                  color: COLORS.gray[1000],
                  textAlign: 'center',
                }}
              >
                {t('errorBoundary.code')}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography
                sx={{
                  fontWeight: { xs: 600, md: 700 },
                  fontSize: { xs: '30px', md: '60px' },
                  lineHeight: { xs: '45px', md: '90px' },
                  color: COLORS.brand.night,
                  textAlign: 'center',
                }}
              >
                {t('errorBoundary.title')}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography
                sx={{
                  fontWeight: { xs: 400, md: 500 },
                  fontSize: { xs: '16px', md: '20px' },
                  lineHeight: { xs: '24px', md: '30px' },
                  color: COLORS.gray[1200],
                  textAlign: 'center',
                }}
              >
                {t('errorBoundary.subtitle')}
              </Typography>
            </Grid>
            <Grid
              item
              xs={12}
              sx={{
                display: 'flex',
                gap: '2em',
                justifyContent: 'center',
                flexDirection: { xs: 'column', md: 'row' },
              }}
            >
              <Button
                color="tertiary"
                startIcon={<ArrowLeftIcon />}
                type="outline"
                onClick={() => handleNavigate(window.location.pathname)}
              >
                {t('notFound.button.goBack')}
              </Button>
              <Button onClick={() => handleNavigate('/')}>{t('notFound.button.home')}</Button>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </Box>
  );
}
